import React from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { NotificationManager } from "react-notifications";
import { Loader } from "../../components/loader";
import { DefaultHeader } from "../../components/defaultHeader";
import {
  fetchConfig,
  addConfig,
  deleteConfig,
  updateConfig,
  setDefaultConfig,
  updateHeader,
  updateTaxRate,
  updateDashboardBanner,
  getDropboxAuthorizedUrl,
} from "../../actions/configuration";
import { fetchAvailablePuppiesToQueue, getAvailablePuppiesFromQueue, updateMultipleMedicalRecordsCallStatus } from "../../actions/medicalRecords";
import { getCurrentPetShop } from "../../actions/petShop";
import HwFindUs from "./howFindUs";
import TypeOfPayments from "./typeOfPayments";

import { convertFromRaw, convertToRaw, EditorState } from "draft-js";
import { ConfigService } from "aws-sdk";
// import 'draft-js/dist/Draft.css';
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import ImageUploader from "react-images-upload";
import AutoUnsubscribeKeywords from "./autoUnsubscribeKeywords";
import Switch from "react-switch";
import ImageCompressor from "./imageCompressor";
import _ from "lodash";

const toolbarConfig = {
  options: ["inline", "list", "link", "history"]
};

class Configuration extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      loadingHeader: false,
      contractTerms: "",
      contractTermsId: "",
      contractPrintSize: "",
      contractPrintSizeId: "",
      headerTypeId: "",
      editorState: null,
      header: [],
      imgSrc: "",
      imgName: "",
      headerType: "default",
      taxRate: 0,
      retryAttemptCount: 0,
      retryAttemptCountId: "",
      pdfOldVersion: "",
      pdfOldVersionId: "",
      videoHoster: null,
      videoHosterId: null,
      emailNotificationConfig: null,
      emailNotificationConfigId: null,
      emailNotificationOffset: 0,
      emailNotificationLimit: 0,
      start: 0,
      end: 0,
      isAutoShuffleOn : false,
      autoShuffleId : null,
      isPuppiesShufflingQueueRunning : false,
      loadingDashboardBanner: false,
      dashboardBanner:[],
      userRole : 'admin',
      loadingCallStatus : false,
      callStatus : true,
      completedShuffleQueuePercentage : 0,     
      // termsEditorState: EditorState.createEmpty()
    };
  }
  onEditorStateChange = editorState => this.setState({ editorState });
  changeVal = event => {
    this.setState({ [event.target.name]: event.target.value });
  };

  changeLimitVal = event => {
    this.setState({ emailNotificationLimit: (event.target.value - this.state.start), end: event.target.value });
  };

  changeOffsetVal = event => {
    this.setState({ emailNotificationOffset: event.target.value, emailNotificationLimit: (this.state.end - event.target.value), start: event.target.value });
  };

  changeUserRole = event =>{ 
    this.setState({ [event.target.name]: event.target.value });

  };

  saveContractTerms = e => {
    e.preventDefault();
    const rawDraftContentState = JSON.stringify(
      convertToRaw(this.state.editorState.getCurrentContent())
    );
    if (rawDraftContentState) {
      const data = {
        value: rawDraftContentState,
        name: "contract_terms",
        type: "petshop"
      };
      this.props.updateConfig(this.state.contractTermsId, data);
    } else {
      NotificationManager.warning("Contract Terms Empty!");
    }
  };
  saveContractPrintSize = e => {
    e.preventDefault();
    if (
      this.state.contractPrintSize === "legal" ||
      this.state.contractPrintSize === "letter"
    ) {
      const data = {
        value: this.state.contractPrintSize,
        name: "contract_print_size",
        type: "petshop"
      };
      this.props.updateConfig(this.state.contractPrintSizeId, data);
    }
  };
  saveTaxRate = e => {
    e.preventDefault();
    if (this.state.taxRate > 0) {
      const data = {
        value: this.state.taxRate,
        name: "default_tax_rate",
        type: "petshop"
      };
      this.props.updateConfig(this.state.taxRateId, data);
    }
  };

  saveRetryAttemptCount = e => {
    e.preventDefault();
    if (this.state.retryAttemptCount >= 0) {
      const data = {
        value: this.state.retryAttemptCount,
        name: "woostore_retry_attempt_count",
        type: "petshop"
      };
      this.props.updateConfig(this.state.retryAttemptCountId, data);
    }
  };

  onDrop = picture => {
    this.setState({
      header: picture
    });
  };

  onDropDashboard = picture => {
    this.setState({
      dashboardBanner: picture
    });
  };

  saveHeader = e => {
    e.preventDefault();
    if (this.state.loadingHeader) {
      return false;
    }
    const data = {
      value: this.state.headerType,
      name: "contract_header_template",
      type: "petshop"
    };
    if (this.state.headerType === "default") {
      this.props.updateConfig(this.state.headerTypeId, data);
    }
    if (this.state.headerType === "upload") {
      // if(this.state.header.length <= 0) {
      //     NotificationManager.warning("No image attached!");
      //     return false;
      // }
      if (this.state.header.length > 1) {
        NotificationManager.warning("Multiple images cannot be uploaded!");
        return false;
      }

      if (this.state.header.length === 0) {
        this.props.updateConfig(this.state.headerTypeId, data);
        return true;
      }

      this.setState({ loadingHeader: true });
      let formData = new FormData();
      formData.append("file", this.state.header[0]);
      formData.append("configData", JSON.stringify(data));
      formData.append(
        "configId",
        JSON.stringify({ id: this.state.headerTypeId })
      );

      this.props.updateHeader(formData);
    }
  };

  changeVideoHoster = (event )=> {
    this.setState({ [event.target.name]: event.target.value });  
  };

  saveVideoHoster = e => {
     e.preventDefault();
     let videoHoster = this.state.videoHoster; 
     let videoHosterId = this.state.videoHosterId;
       const data = {
         value: videoHoster,
         name: "video_hoster",
         type: "petshop"
       };
     this.props.updateConfig(videoHosterId, data);
     
  };

  saveEmailNotificationConfigs = e => {
    e.preventDefault();
    let emailNotificationConfigId = this.state.emailNotificationConfigId;
      const data = {
        value: JSON.stringify({
          limit: this.state.emailNotificationLimit,
          offset: this.state.emailNotificationOffset
        }),
        name: "email_notification_limit_offset",
        type: "petshop"
      };
    this.props.updateConfig(emailNotificationConfigId, data);
    
 };

 saveDashoardBanner = e => {
  e.preventDefault();
  if (this.state.loadingDashboardBanner) {
    return false;
  }

  if (this.state.dashboardBanner.length > 1) {
    NotificationManager.warning("Multiple images cannot be uploaded!");
    return false;
  }

  this.setState({ loadingDashboardBanner: true });
  let formData = new FormData();
  formData.append("file", this.state.dashboardBanner[0]);
  let userRole = this.state.userRole;    
  this.props.updateDashboardBanner(userRole,formData);
  
};

  saveOldPdfVersion = e => {  
    e.preventDefault();  
      const data = {
        value: this.state.pdfOldVersion,
        name: "pdf_old_version",
        type: "petshop"
      };
      this.props.updateConfig(this.state.pdfOldVersionId, data);
 
  };

  handlePdfVersionChange = (checked) => {    
    this.setState({ pdfOldVersion:checked });
  };

  handleVideoCallStatusChange = (checked) => {    
    let callStatus = checked ? 'on' : 'off';
    this.setState({ callStatus:checked, loadingCallStatus : true });
    this.props.updateMultipleMedicalRecordsCallStatus(callStatus);
  };

  changeShuffleStatus = (checked) => { 
   const data = {  
    value: checked,
    name: "auto_shuffle",
    type: "petshop"
  };
    this.props.updateConfig(this.state.autoShuffleId, data);
  }

  startManualShuffle = (e) => {
    e.preventDefault();  
    this.props.fetchAvailablePuppiesToQueue();
    this.setState( { isPuppiesShufflingQueueRunning : true });
  }

  sendDropBoxLink = (e) => {   
    e.preventDefault(); 
    this.props.getDropboxAuthorizedUrl();
  }

  componentDidMount() {
    this.props.fetchConfig();
    this.props.getAvailablePuppiesFromQueue();
  }
  componentWillReceiveProps = nextProps => {
    // if(this.props.data.newConfig !== nextProps.data.newConfig) {
    //     this.setState({loading: false, newConfig: ''});
    //     this.props.fetchConfig();
    //     NotificationManager.success("Configuraton added successfully");
    // }
    // if(this.props.data.newConfigError !== nextProps.data.newConfigError) {
    //     this.setState({loading: false, newConfig: ''});
    //     NotificationManager.error("Faild to save new configuration.");
    // }

    if (
      this.props.data.updatedConfig !== nextProps.data.updatedConfig ) {
      this.setState({
        loading: false,
        contractTerms: "",
        contractTermsId: "",
        contractPrintSize: "",
        contractPrintSizeId: "",
        headerTypeId: "",
        retryAttemptCount: 0,
        retryAttemptCountId: "",
        header: [],
       
      });
      this.props.fetchConfig();
      NotificationManager.success("Configuraton updated successfully");
    }

    // if(this.props.data.selectedToDelete !== nextProps.data.selectedToDelete) {
    //     $('#confirm_delete_modal').modal('hide');
    //     this.setState({loadingDelete: false, selectedId: ''});
    //     this.props.fetchHwFindUs();
    //     NotificationManager.success("Type Deleted Successfully");
    // }

    if (
      this.props.data.updatedConfigError !== nextProps.data.updatedConfigError
    ) {
      this.setState({
        loading: false,
        contractTerms: "",
        contractTermsId: "",
        taxRate: "",
        taxRateId: "",
        contractPrintSize: "",
        contractPrintSizeId: "",
        retryAttemptCount: 0,
        retryAttemptCountId: "",
        headerTypeId: "",
        header: []
      });
      NotificationManager.error("Faild to update type.");
    }

    if (this.props.data.configs !== nextProps.data.configs) {
      let configs = nextProps.data.configs;

      if (configs.length < 1) {
        this.props.setDefaultConfig();
      }
      configs.map((item, index) => {
        if (item.name === "contract_terms") {
          let contentState = null;
          if (!(item.value === "{}")) {
            contentState = EditorState.createWithContent(
              convertFromRaw(JSON.parse(item.value))
            );
          }
          this.setState({
            editorState: contentState,
            contractTermsId: item.id
          });
        }
        if (item.name === "contract_print_size") {
          this.setState({
            contractPrintSize: item.value,
            contractPrintSizeId: item.id
          });
        }
        if (item.name === "contract_header_template") {
          this.setState({ headerType: item.value, headerTypeId: item.id });
        }
        if (item.name === "default_tax_rate") {
          this.setState({ taxRate: item.value, taxRateId: item.id });
        }
        if (item.name === "woostore_retry_attempt_count") {
          this.setState({ retryAttemptCount: item.value, retryAttemptCountId: item.id });
        }
        if (item.name === "pdf_old_version") {
          if(item.value == 1){
            this.setState({ pdfOldVersion: true, pdfOldVersionId: item.id });
          }
          else{
            this.setState({ pdfOldVersion: false, pdfOldVersionId: item.id });
          }      
        }
        if (item.name === "video_hoster") {       
          this.setState({ videoHoster: item.value, videoHosterId: item.id });
        }

        if (item.name === "email_notification_limit_offset") {  
          let values = JSON.parse(item.value);

          this.setState({ emailNotificationLimit: values.limit, emailNotificationOffset: values.offset , emailNotificationConfigId: item.id, start: values.offset, end: (Number(values.limit) + Number(values.offset)) });
        }

        if (item.name === "auto_shuffle") {
          if(item.value == 1){
            this.setState({ isAutoShuffleOn: true, autoShuffleId: item.id });
          }
          else{
            this.setState({ isAutoShuffleOn: false, autoShuffleId: item.id });
          }      
        }

      });
    }
    if (this.props.data.setDefault !== nextProps.data.setDefault) {
      this.props.fetchConfig();
    }

    if (this.props.data.headerImage !== nextProps.data.headerImage) {
      this.setState({ loadingHeader: false, header: "" });

      let split_1 = window.location.hostname.split(".")[0];
      if (split_1 === "192") split_1 = "localhost";
      this.props.getCurrentPetShop(split_1);

      NotificationManager.success("Header Image Updated Successfully");
    }  

    if (nextProps.fetchedAvailablePuppies && this.props.fetchedAvailablePuppies !== nextProps.fetchedAvailablePuppies) { 
      const shuffleQueue = nextProps.fetchedAvailablePuppies;
      const waitingpuppyCount = shuffleQueue.allShufflePuppyCount - shuffleQueue.completedShufflePuppiesCount;
      const totalPuppyCount = shuffleQueue.allShufflePuppyCount;
      this.setState({ waitingShuffleQueuePuppyCount : waitingpuppyCount, totalShuffleQueuePuppyCount : totalPuppyCount  });  
    }

    if (this.props.data.dashboardBanner !== nextProps.data.dashboardBanner) {
      this.setState({ loadingDashboardBanner: false });

      let split_1 = window.location.hostname.split(".")[0];
      if (split_1 === "192") split_1 = "localhost";
      this.props.getCurrentPetShop(split_1);

      NotificationManager.success("Dashboard Banner Updated Successfully");
    }

    if(this.props.updatedCallStatusRecords !== nextProps.updatedCallStatusRecords){
        NotificationManager.success("Glocal call status Updated Successfully");
        this.setState({ loadingCallStatus : false});
    }

    if(nextProps.updatedCallStatusRecordsError && this.props.updatedCallStatusRecordsError !== nextProps.updatedCallStatusRecordsError){
      NotificationManager.error("An error occurred while changing the call status");
      this.setState({ loadingCallStatus : false});
    }

    if(nextProps.data.ceratedDropBoxUrl) {
      const url =  nextProps.data.ceratedDropBoxUrl;
      window.open(url,"_blank");     
    }  

    if(this.props.shuffleAvailablePuppiesFromQueue !== nextProps.shuffleAvailablePuppiesFromQueue){     
       let shuffleQueue = nextProps.shuffleAvailablePuppiesFromQueue;
       if(!_.isEmpty(shuffleQueue)){
        const waitingpuppyCount = shuffleQueue.allShufflePuppyCount - shuffleQueue.completedShufflePuppiesCount;
        const totalPuppyCount = shuffleQueue.allShufflePuppyCount;
          if(shuffleQueue.isPuppiesInQueue){    
            const completePercentageTemp = (shuffleQueue.completedShufflePuppiesCount / shuffleQueue.allShufflePuppyCount)*100;       
            let completePercentage = completePercentageTemp.toFixed();          
            this.setState({ isPuppiesShufflingQueueRunning : true, completedShuffleQueuePercentage : completePercentage, waitingShuffleQueuePuppyCount : waitingpuppyCount, totalShuffleQueuePuppyCount : totalPuppyCount }); 
          }else{       
            this.setState({ isPuppiesShufflingQueueRunning : false, waitingShuffleQueuePuppyCount : waitingpuppyCount, totalShuffleQueuePuppyCount : totalPuppyCount}); 
          }     
       }      
    }
   
  };

  componentDidUpdate = (prevProps, prevState) => {
    if (prevState.header !== this.state.header) {}
  };

  render() {
    const {
      contractTerms,
      contractPrintSize,
      editorState,
      loadingHeader,
      headerType,
      videoHoster,
      emailNotificationLimit,
      emailNotificationOffset,
      start,
      end,
      isAutoShuffleOn,
      autoShuffleId,
      isPuppiesShufflingQueueRunning,
      loadingDashboardBanner,
      loadingCallStatus,
      completedShuffleQueuePercentage,
      waitingShuffleQueuePuppyCount,
      totalShuffleQueuePuppyCount,
    } = this.state;
    const { petShop } = this.props;
    return (
      <div className="row">
        <div className="col-md-6">
          <div className="m-portlet">
            <div className="m-portlet__head">
              <div className="m-portlet__head-caption">
                <div className="m-portlet__head-title">
                  <span className="m-portlet__head-icon m--hide">
                    <i className="la la-gear"></i>
                  </span>
                  <h3 className="m-portlet__head-text">Default Contract Layout</h3>
                </div>
              </div>
            </div>
            <form className="m-form">
              <div className="m-portlet__body">
                <div className="m-form__section m-form__section--first">
                  <div className="form-group m-form__group">
                    <label for="example_input_full_name">
                      Choose paper size for printing:
                    </label>
                    <div className="row">
                      <div className="col-md-6">
                        <label className="m-option">
                          <span className="m-option__control">
                            <span className="m-radio m-radio--brand m-radio--check-bold">
                              <input
                                type="radio"
                                name="contractPrintSize"
                                value="legal"
                                checked={contractPrintSize === "legal"}
                                onChange={this.changeVal}
                              />
                              <span></span>
                            </span>
                          </span>
                          <span className="m-option__label">
                            <span className="m-option__head">
                              <span className="m-option__title">Legal</span>
                            </span>
                            <span className="m-option__body">
                              The common size of paper in the US. (8½ × 14
                              inches)
                            </span>
                          </span>
                        </label>
                      </div>
                      <div className="col-md-6">
                        <label className="m-option">
                          <span className="m-option__control">
                            <span className="m-radio m-radio--brand m-radio--check-bold">
                              <input
                                type="radio"
                                name="contractPrintSize"
                                value="letter"
                                checked={contractPrintSize === "letter"}
                                onChange={this.changeVal}
                              />
                              <span></span>
                            </span>
                          </span>
                          <span className="m-option__label">
                            <span className="m-option__head">
                              <span className="m-option__title">Letter</span>
                            </span>
                            <span className="m-option__body">
                              The normal size of A4 paper. (8½ × 11 inches)
                            </span>
                          </span>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="m-portlet__foot m-portlet__foot--fit">
                <div className="m-form__actions m--align-right">
                  {/* <button
                    type="reset"
                    className="btn btn-secondary m-btn--pill mx-2"
                  >
                    Cancel
                  </button> */}
                  <button
                    type="submit"
                    className="btn btn-primary m-btn--pill"
                    onClick={this.saveContractPrintSize}
                  >
                    Save
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
        <div className="col-md-6">
          <div className="m-portlet">
            <div className="m-portlet__head">
              <div className="m-portlet__head-caption">
                <div className="m-portlet__head-title">
                  <span className="m-portlet__head-icon m--hide">
                    <i className="la la-gear"></i>
                  </span>
                  <h3 className="m-portlet__head-text">Tax Rate</h3>
                </div>
              </div>
            </div>
            <form className="m-form">
              <div className="m-portlet__body">
                <div className="input-group m-input-group">
                  <div className="input-group-prepend">
                    <span className="input-group-text">%</span>
                  </div>{" "}
                  <input
                    type="number"
                    name="taxRate"
                    maxLength={2}
                    onChange={this.changeVal}
                    value={this.state.taxRate}
                    className="form-control m-input mr-2"
                    placeholder="Enter tax rate as percentage.."
                  />
                </div>
              </div>
              <div className="m-portlet__foot m-portlet__foot--fit">
                <div className="m-form__actions m--align-right">
                  <button
                    onClick={this.saveTaxRate}
                    className="btn btn-primary m-btn m-btn--icon m-btn--pill mt-4"
                  >
                    <span>
                      <i className="la la-save"></i>
                      <span>Save</span>
                    </span>
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
        <div className="col-md-6">
          <div className="m-portlet">
            <div className="m-portlet__head">
              <div className="m-portlet__head-caption">
                <div className="m-portlet__head-title">
                  <span className="m-portlet__head-icon m--hide">
                    <i className="la la-gear"></i>
                  </span>
                  <h3 className="m-portlet__head-text">How You Find Us?</h3>
                </div>
              </div>
            </div>
            <form className="m-form">
              <HwFindUs />
            </form>
          </div>
        </div>

        <div className="col-md-6">
          <div className="m-portlet">
            <div className="m-portlet__head">
              <div className="m-portlet__head-caption">
                <div className="m-portlet__head-title">
                  <span className="m-portlet__head-icon m--hide">
                    <i className="la la-gear"></i>
                  </span>
                  <h3 className="m-portlet__head-text">Type of Payments</h3>
                </div>
              </div>
            </div>
            <form className="m-form">
              <TypeOfPayments />
            </form>
          </div>
        </div>
        <div className="col-md-6">
          <div className="m-portlet">
            <div className="m-portlet__head">
              <div className="m-portlet__head-caption">
                <div className="m-portlet__head-title">
                  <span className="m-portlet__head-icon m--hide">
                    <i className="la la-gear"></i>
                  </span>
                  <h3 className="m-portlet__head-text">
                    Contract Document Template
                  </h3>
                </div>
              </div>
            </div>
            <form className="m-form">
              <div className="m-portlet__body">
                <div className="m-form__section m-form__section--first">
                  <div className="form-group m-form__group">
                    <label for="example_input_full_name">
                      Select contract document header:
                    </label>
                    <div className="row mb-3">
                      <div className="col-md-6">
                        <label className="m-option">
                          <span className="m-option__control">
                            <span className="m-radio m-radio--brand m-radio--check-bold">
                              <input
                                type="radio"
                                name="headerType"
                                value="default"
                                checked={headerType === "default"}
                                onChange={this.changeVal}
                              />
                              <span></span>
                            </span>
                          </span>
                          <span className="m-option__label">
                            <span className="m-option__head">
                              <span className="m-option__title">Header</span>
                            </span>
                            <span className="m-option__body">
                              This will be the default template recommended by
                              petpos
                            </span>
                          </span>
                        </label>
                      </div>
                      <div className="col-md-6">
                        <label className="m-option">
                          <span className="m-option__control">
                            <span className="m-radio m-radio--brand m-radio--check-bold">
                              <input
                                type="radio"
                                name="headerType"
                                value="upload"
                                checked={headerType === "upload"}
                                onChange={this.changeVal}
                              />
                              <span></span>
                            </span>
                          </span>
                          <span className="m-option__label">
                            <span className="m-option__head">
                              <span className="m-option__title">Custom Header</span>
                            </span>
                            <span className="m-option__body">
                              Upload and set your own image as header
                            </span>
                          </span>
                        </label>
                      </div>
                    </div>
                    {headerType === "upload" && (
                      <React.Fragment>
                        <div className="row">
                          <div className="col-12">
                            <img
                              src={
                                petShop.header_path
                                  ? process.env.REACT_APP_S3_PATH +
                                    "/" +
                                    petShop.header_path
                                  : ""
                              }
                              alt=""
                              className="w-100 mb-3 m-width-600"
                            />
                          </div>
                        </div>
                        {!loadingHeader ? (
                          <React.Fragment>
                            <label for="example_input_full_name">
                              Choose header for contract:
                            </label>
                            <ImageUploader
                              withIcon={true}
                              buttonText="Choose image"
                              onChange={this.onDrop}
                              imgExtension={[".jpg", ".png"]}
                              maxFileSize={5242880}
                              singleImage={true}
                              withPreview={true}
                              label="Max file size: 5mb, Accepted: jpg, png"
                            />
                          </React.Fragment>
                        ) : (
                          <div style={{ textAlign: "center" }}>
                            <Loader type="line-scale" active={true} />
                          </div>
                        )}
                      </React.Fragment>
                    )}
                    {headerType === "default" && (
                      <DefaultHeader petShop={petShop} />
                    )}
                  </div>
                </div>
              </div>
              <div className="m-portlet__body">
                <div className="m-form__section m-form__section--first">
                  <div className="form-group m-form__group"></div>
                </div>
              </div>
              <div className="m-portlet__foot m-portlet__foot--fit">
                <div className="m-form__actions m--align-right">
                  {/* <button
                    type="reset"
                    className="btn btn-secondary m-btn--pill mx-2"
                  >
                    Cancel
                  </button> */}
                  <button
                    type="submit"
                    className="btn btn-primary m-btn--pill"
                    onClick={this.saveHeader}
                  >
                    Save
                  </button>
                </div>
              </div>
            </form>
          </div>
          <div />
        </div>
        <div className="col-md-6">
          <div className="m-portlet">
            <div className="m-portlet__head">
              <div className="m-portlet__head-caption">
                <div className="m-portlet__head-title">
                  <span className="m-portlet__head-icon m--hide">
                    <i className="la la-gear"></i>
                  </span>
                  <h3 className="m-portlet__head-text">Contract Terms</h3>
                </div>
              </div>
            </div>
            <form className="m-form">
              <div className="m-portlet__body">
                {/* <div className="form-group m-form__group m--margin-top-10">
                    <div className="alert m-alert m-alert--default" role="alert">
                        Enter your custom Terms & Conditions here.
                    </div>
                </div> */}
                <div className="form-group m-form__group">
                  <Editor
                    toolbar={toolbarConfig}
                    editorState={editorState}
                    toolbarClassName="toolbarClassName"
                    wrapperClassName="wrapperClassName"
                    editorClassName="editorClassName"
                    onEditorStateChange={this.onEditorStateChange}
                  />
                </div>
              </div>
              <div className="m-portlet__foot m-portlet__foot--fit">
                <div className="m-form__actions m--align-right">
                  {/* <button
                    type="reset"
                    className="btn btn-secondary m-btn--pill mx-2"
                  >
                    Cancel
                  </button> */}
                  <button
                    type="submit"
                    className="btn btn-primary m-btn--pill"
                    onClick={this.saveContractTerms}
                  >
                    Save
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>

        <div className="col-md-6">
          <div className="m-portlet">
            <div className="m-portlet__head">
              <div className="m-portlet__head-caption">
                <div className="m-portlet__head-title">
                  <span className="m-portlet__head-icon m--hide">
                    <i className="la la-gear"></i>
                  </span>
                  <h3 className="m-portlet__head-text">Woo Store Configuration</h3>
                </div>
              </div>
            </div>
            <form className="m-form">
              <div className="m-portlet__body">
                <span className="m-portlet__head-icon m--hide">
                  <i className="la la-gear"></i>
                </span>
                <div className="row">
                  <div className="col-md-4 mt-auto">
                    <p>Retry Attempt Count</p>
                  </div>
                  <div className="col-md-8">
                    <input
                      type="number"
                      name="retryAttemptCount"
                      min={0}
                      maxLength={2}
                      onChange={this.changeVal}
                      value={this.state.retryAttemptCount}
                      disabled={true}
                      className="form-control m-input mr-2"
                      placeholder="Enter retry attempt count.."
                    />
                  </div>
                </div>
              </div>
              <div className="m-portlet__foot m-portlet__foot--fit">
                <div className="m-form__actions m--align-right">
                  <button
                    type="submit"
                    className="btn btn-primary m-btn--pill"
                    disabled={true}
                    onClick={this.saveRetryAttemptCount}>
                    Save
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
        <div className="col-md-6">
          <div className="m-portlet">
            <div className="m-portlet__head">
              <div className="m-portlet__head-caption">
                <div className="m-portlet__head-title">
                  <span className="m-portlet__head-icon m--hide">
                    <i className="la la-gear"></i>
                  </span>
                  <h3 className="m-portlet__head-text">Auto unsubscribe keywords</h3>
                </div>
              </div>
            </div>
            <form className="m-form">
              <AutoUnsubscribeKeywords />
            </form>
          </div>
        </div>
        <div className="col-md-6">
          <div className="m-portlet">
            <div className="m-portlet__head">
              <div className="m-portlet__head-caption">
                <div className="m-portlet__head-title">
                  <span className="m-portlet__head-icon m--hide">
                    <i className="la la-gear"></i>
                  </span>
                  <h3 className="m-portlet__head-text">Legacy Module Configuration</h3>
                </div>
              </div>
            </div>
            <form className="m-form">
              <div className="m-portlet__body">
                <span className="m-portlet__head-icon m--hide">
                  <i className="la la-gear"></i>
                </span>
                <div className="row">
                  <div className="col-md-4 mt-auto">
                    <p>Enable Legacy Modules</p>
                  </div>
                  <div className="col-md-8">                 
                    <Switch onChange={this.handlePdfVersionChange} checked={this.state.pdfOldVersion} uncheckedIcon={false} checkedIcon={false} onColor={"#28a745"}/>
                  </div>
                </div>
              </div>
              <div className="m-portlet__foot m-portlet__foot--fit">
                <div className="m-form__actions m--align-right">              
                  <button
                    type="submit"
                    className="btn btn-primary m-btn--pill"              
                    onClick={this.saveOldPdfVersion}>
                    Save
                  </button>               
              
                </div>
              </div> 
            </form>
          </div>
        </div>
        <div className="col-md-6">
          <div className="m-portlet">
            <div className="m-portlet__head">
              <div className="m-portlet__head-caption">
                <div className="m-portlet__head-title">
                  <span className="m-portlet__head-icon m--hide">
                    <i className="la la-gear"></i>
                  </span>
                  <h3 className="m-portlet__head-text">Video Upload Service</h3>
                </div>
              </div>
            </div>
            <form className="m-form">
              <div className="m-portlet__body">
                <span className="m-portlet__head-icon m--hide">
                  <i className="la la-gear"></i>
                </span>
                <div className="row">           
                  <div className="col-12">
                     <select className="form-control m-input" onChange={this.changeVideoHoster} value={videoHoster} name="videoHoster" id="videoHoster">
                       <option value="wistia">Wistia</option>
                       <option value="vimeo">Vimeo</option>  
                      </select>
                      <span className='m-form__help'>Please Select the Video Service</span>
                  </div>
                </div>
              </div>
              <div className="m-portlet__foot m-portlet__foot--fit">
                <div className="m-form__actions m--align-right">
                  <button
                    type="submit"
                    className="btn btn-primary m-btn--pill"            
                    onClick={this.saveVideoHoster}>
                    Save
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
        <div className="col-md-6">
          <div className="m-portlet">
            <div className="m-portlet__head">
              <div className="m-portlet__head-caption">
                <div className="m-portlet__head-title">
                  <span className="m-portlet__head-icon m--hide">
                    <i className="la la-gear"></i>
                  </span>
                  <h3 className="m-portlet__head-text">Image Optimization</h3>
                </div>
              </div>
            </div>
            <form className="m-form">
              <ImageCompressor />
            </form>
          </div>
        </div>
        <div className="col-md-6">
          <div className="m-portlet">
            <div className="m-portlet__head">
              <div className="m-portlet__head-caption">
                <div className="m-portlet__head-title">
                  <span className="m-portlet__head-icon m--hide">
                    <i className="la la-gear"></i>
                  </span>
                  <h3 className="m-portlet__head-text">Email Notification Configurations</h3>
                </div>
              </div>
            </div>
            <form className="m-form">
              <div className="m-portlet__body">
                <span className="m-portlet__head-icon m--hide">
                  <i className="la la-gear"></i>
                </span>
                <div className="row">
                  <div className="form-group m-form__group" style={{paddingTop: 0}}>
                    <label className="col-xl-3 col-lg-3 col-form-label">
                      Start:
                    </label>
                    <div className="col-xl-9 col-lg-9">                 
                      <input
                        type="text"
                        name="start"
                        value={start}
                        onChange={e => this.changeOffsetVal(e)}
                        className="form-control m-input mr-2"
                        placeholder="Add start"
                      />
                    </div>
                  </div> 
                  <div className="form-group m-form__group" style={{paddingTop: 0}}>
                    <label className="col-xl-3 col-lg-3 col-form-label">
                      End:
                    </label>
                    <div className="col-xl-9 col-lg-9">                 
                        <input
                          type="number"
                          name="end"
                          value={end}
                          onChange={e => this.changeLimitVal(e)}
                          className="form-control m-input mr-2"
                          placeholder="Add Limit"
                        />
                    </div>
                  </div> 
                </div>
              </div>
              <div className="m-portlet__foot m-portlet__foot--fit">
                <div className="m-form__actions m--align-right">
                  <button
                    type="submit"
                    className="btn btn-primary m-btn--pill"            
                    onClick={this.saveEmailNotificationConfigs}>
                    Save
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
        <div className="col-md-6">
          <div className="m-portlet">
            <div className="m-portlet__head">
              <div className="m-portlet__head-caption">
                <div className="m-portlet__head-title">
                  <span className="m-portlet__head-icon m--hide">
                    <i className="la la-gear"></i>
                  </span>
                  <h3 className="m-portlet__head-text">Pet Shuffle</h3>
                </div>
              </div>
            </div>
            <form className="m-form">
              <div className="m-portlet__body">
                <span className="m-portlet__head-icon m--hide">
                  <i className="la la-gear"></i>
                </span>
                <div className="m-widget4">
                  <div className="m-widget4__item">
                    <div className="m-widget4__info">
                      <span className="m-widget4__title">
                        Auto Shuffle
                      </span>
                    </div>
                    <div className="m-widget4__ext">              
                       <Switch 
                        onChange={this.changeShuffleStatus} 
                        checked={isAutoShuffleOn} 
                        uncheckedIcon={false} 
                        checkedIcon={false}                               
                        onColor={"#28a745"}
                        offColor={"#f4516c"}
                        />
                    </div>
                  </div>
                  <div class="m-widget4__item">
                    <div class="m-widget4__info">
                      <span class="m-widget4__title">
                        Manual Shuffle
                      </span>
                    <br/>
                    {  isPuppiesShufflingQueueRunning &&               
                      <span className="m-widget4__sub">
                        <span>                    
                          {waitingShuffleQueuePuppyCount} puppies in progress ({totalShuffleQueuePuppyCount} total). 
                        </span> 
                       <div className="progress">
											 <div 
                          className="progress-bar bg-success" 
                          role="progressbar" 
                          style={{width: `${completedShuffleQueuePercentage}%`}} 
                          aria-valuenow = {completedShuffleQueuePercentage} 
                          aria-valuemin="0" 
                          aria-valuemax="100">
                            {completedShuffleQueuePercentage}%
                          </div>
												</div>
                      </span>
                    }
                    </div>
                    <div class="m-widget4__ext">
                      {
                      isPuppiesShufflingQueueRunning ?
                      <button
                        className="btn m-btn--pill btn-warning m-btn m-btn--custom"   
                        disabled           
                      >
                        In progress
                      </button>:
                        <button    
                          className="btn m-btn--pill btn-success m-btn m-btn--custom"              
                          onClick={this.startManualShuffle}>
                        Start
                      </button>
                      }
                    </div>
                  </div>      
               </div>          
              </div>      
            </form>
          </div>
        </div>
        <div className="col-md-6">
          <div className="m-portlet">
            <div className="m-portlet__head">
              <div className="m-portlet__head-caption">
                <div className="m-portlet__head-title">
                  <span className="m-portlet__head-icon m--hide">
                    <i className="la la-gear"></i>
                  </span>
                  <h3 className="m-portlet__head-text">Drop Box Authentication</h3>
                </div>
              </div>
            </div>
            <form className="m-form">
              <div className="m-portlet__body">
                <span className="m-portlet__head-icon m--hide">
                  <i className="la la-gear"></i>
                </span>
                <div className="m-widget4">
                  <div className="m-widget4__item">
                    <div className="m-widget4__info">
                      <span className="m-widget4__title">
                        Drop Box Authentication
                      </span>
                    </div>
                    <div className="m-widget4__ext">
              
                        <button          
                          className="btn m-btn--pill btn-success m-btn m-btn--custom  "              
                          onClick={(e) => this.sendDropBoxLink(e)}>
                            Autherize
                        </button>       
           
                    </div>
                  </div>            
               </div>          
              </div>      
            </form>
          </div>
        </div>
        <div className="col-md-6">
          <div className="m-portlet">
            <div className="m-portlet__head">
              <div className="m-portlet__head-caption">
                <div className="m-portlet__head-title">
                  <span className="m-portlet__head-icon m--hide">
                    <i className="la la-gear"></i>
                  </span>
                  <h3 className="m-portlet__head-text">Dashboard Banner Settings</h3>
                </div>
              </div>
            </div>
            <form className="m-form">
              <div class="m-portlet__body">
                <div class="m-form__section m-form__section--first">
                  <div class="form-group m-form__group">     
                      <React.Fragment>                

                        <div className="row">  
                         {  petShop.dashboard_banner_path &&                    
                          <div className="col-4">
                            <div className="row justify-content-center">
                              <div className="col-12">
                                <img
                                  src={
                                    petShop.dashboard_banner_path
                                    ? process.env.REACT_APP_S3_PATH +
                                    "/" +
                                    petShop.dashboard_banner_path
                                    : ""
                                  }
                                  alt=""
                                  className="w-100 mb-3 m-width-600"
                                  width= "150px"
                                  height= "150px"
                                />
                              </div>                        
                            </div>
                            <div className="row justify-content-center">                    
                              <label className="col-form-label">Admin</label>
                            </div>                          
                          </div>
                          }
                          { petShop.cashier_dashboard_banner_path &&
                          <div className="col-4">
                            <div className="row justify-content-center">
                              <div className="col-12">
                                <img
                                  src={
                                    petShop.cashier_dashboard_banner_path
                                    ? process.env.REACT_APP_S3_PATH +
                                    "/" +
                                    petShop.cashier_dashboard_banner_path
                                    : ""
                                  }
                                  alt=""
                                  className="w-100 mb-3 m-width-600"
                                  width= "213px"
                                  height= "150px"
                                />
                              </div>                        
                            </div>
                            <div className="row justify-content-center">
                                 <label className="col-form-label">Cashier</label>
                            </div>                          
                          </div>
                          }
                          { petShop.caretaker_dashboard_banner_path &&
                          <div className="col-4">
                            <div className="row justify-content-center">
                              <div className="col-12">
                                <img
                                  src={
                                    petShop.caretaker_dashboard_banner_path
                                    ? process.env.REACT_APP_S3_PATH +
                                    "/" +
                                    petShop.caretaker_dashboard_banner_path
                                    : ""
                                  }
                                  alt=""
                                  className="w-100 mb-3 m-width-600"
                                  width= "213px"
                                  height= "150px"
                                />
                              </div>                        
                            </div>
                            <div className="row justify-content-center">
                               <label className="col-form-label">Care Taker</label>
                            </div>
                          
                          </div>
                          }
                        </div>               
                   
                        {!loadingDashboardBanner ? (
                          <React.Fragment className="mt-2">
                      
                            <select
                                type="text"
                                name="userRole"
                                onChange={this.changeUserRole}
                                className="form-control m-input mt-3"                          
                                value={this.state.userRole}
                             >
                                <option value="admin">Admin</option>                  
                                <option value="cashier">Cashier</option>
                                <option value="caretaker">Care Taker</option>
                            </select>
                            <label for="example_input_full_name" className="mt-2">
                              Choose user role
                            </label>
                            <ImageUploader
                              withIcon={true}
                              buttonText="Choose image"
                              onChange={this.onDropDashboard}
                              imgExtension={[".jpg", ".jpeg", ".png"]}
                              maxFileSize={5242880}
                              singleImage={true}
                              withPreview={true}
                              label="Max file size: 5mb, Accepted: jpg, png"
                            />
                          </React.Fragment>
                        ) : (
                          <div style={{ textAlign: "center" }}>
                            <Loader type="line-scale" active={true} />
                          </div>
                        )}
                      </React.Fragment> 
                      <div className="row">
                        <ul>
                          <li>Admin banner should be 300x300 pixels</li>
                          <li>Cashier and Care Taker  banners should be 426x300 pixels</li>
                        </ul>
                      </div>                
                  </div>
                </div>
              </div>
              <div class="m-portlet__body">
                <div class="m-form__section m-form__section--first">
                  <div class="form-group m-form__group"></div>
                </div>
              </div>
              <div className="m-portlet__foot m-portlet__foot--fit">
                <div className="m-form__actions m--align-right">   
                  <button
                    type="submit"
                    className="btn btn-primary m-btn--pill"
                    onClick={this.saveDashoardBanner}
                  >
                    Save
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
        <div className="col-md-6">
          <div className="m-portlet">
            <div className="m-portlet__head">
              <div className="m-portlet__head-caption">
                <div className="m-portlet__head-title">
                  <span className="m-portlet__head-icon m--hide">
                    <i className="la la-gear"></i>
                  </span>
                  <h3 className="m-portlet__head-text">Arrange a video call</h3>
                </div>
              </div>
            </div>
            <form className="m-form">
              <div className="m-portlet__body">
                <span className="m-portlet__head-icon m--hide">
                  <i className="la la-gear"></i>
                </span>
                <div className="m-widget4">
                  <div className="m-widget4__item">
                    <div className="m-widget4__info">
                      <span className="m-widget4__title">
                        Global Enable
                      </span>
                    </div>
                    <div className="m-widget4__ext">
                      { !loadingCallStatus ?
                      <Switch 
                       onChange={this.handleVideoCallStatusChange} 
                       checked={this.state.callStatus} 
                       uncheckedIcon={false} 
                       checkedIcon={false}                               
                       onColor={"#28a745"}
                       offColor={"#f4516c"}
                       
                       />:
                       <div style={{ textAlign: "center" }}>
                         <Loader type="line-scale" active={true} size={25} />
                       </div>
                       }
                    </div>
                  </div>
                  {/* <div class="m-widget4__item">
                    <div class="m-widget4__info">
                      <span class="m-widget4__title">
                        Pin To Top
                      </span>                
                    </div>
                    <div class="m-widget4__ext">
                      <Switch 
                      onChange={this.handlePdfVersionChange} 
                      checked={this.state.pdfOldVersion} 
                      uncheckedIcon={false} 
                      checkedIcon={false} 
                      onColor={"#28a745"}/>
                    </div>
                 </div> */}
               </div>          
              </div>      
            </form>
          </div>
        </div>
      </div>
    );
  }
}
const mapStateToProps = state => ({
  user: state.cognito.user, 
  petShop: state.petShopReducer.currentPetshop,
  data: state.configReducer,
  shuffleAvailablePuppiesFromQueue : state.medicalRecordsReducer.shuffleAvailablePuppiesFromQueue,
  fetchedAvailablePuppies : state.medicalRecordsReducer.fetchedAvailablePuppies,
  updatedCallStatusRecords : state.medicalRecordsReducer.updatedCallStatusRecords,
  updatedCallStatusRecordsError : state.medicalRecordsReducer.updatedCallStatusRecordsError,
});
const mapDispatchToProps = dispatch => ({
  fetchConfig: () => {
    dispatch(fetchConfig());
  },
  addConfig: data => {
    dispatch(addConfig(data));
  },
  deleteConfig: id => {
    dispatch(deleteConfig(id));
  },
  updateConfig: (id, data) => {
    dispatch(updateConfig(id, data));
  },
  setDefaultConfig: () => {
    dispatch(setDefaultConfig());
  },
  updateHeader: img => {
    dispatch(updateHeader(img));
  },
  getCurrentPetShop: t => {
    dispatch(getCurrentPetShop(t));
  },
  fetchAvailablePuppiesToQueue: (data) => {
    dispatch(fetchAvailablePuppiesToQueue(data));
  },
  getAvailablePuppiesFromQueue: () => {
    dispatch(getAvailablePuppiesFromQueue());
  },  
  updateDashboardBanner: (userRole,image) => {
    dispatch(updateDashboardBanner(userRole,image));
  },
  updateMultipleMedicalRecordsCallStatus: (status) => {
    dispatch(updateMultipleMedicalRecordsCallStatus(status));
  },
  getDropboxAuthorizedUrl: () => {
    dispatch(getDropboxAuthorizedUrl());
  }
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Configuration)
);
